export default "__VITE_ASSET__DdvFsppJ__"